import { PHONE_EMPTY_REGEX, PHONE_CORRECT_REGEX, PHONE_MASK } from '../constants/formats';

export const parsePhoneNumber = (phone) => {
    return `+` + phone.replace(/\D/gi, '');
}

export const validate = phone =>
    (!PHONE_CORRECT_REGEX.test(phone)) ?
        '*Некорректный номер' :
        undefined;

export const required = phone =>
    (!phone || PHONE_EMPTY_REGEX.test(phone)) ?
        '*Обязательно для заполнения' :
        undefined;

export function formatPhone(phone) {
    if (!phone)
        return '';

    let i = 0;
    const formated = PHONE_MASK.replace(/\\/g, '').replace(/\d|\+/g, _ => phone[i++]);

    if (!PHONE_CORRECT_REGEX.test(formated))
        return phone;

    return formated;
}


// WEBPACK FOOTER //
// ./src/extensions/phoneHelper.js